module.exports = __webpack_public_path__ + "static/media/compass.4f1f49a2.svg";